<template>
  <div class="hotel-card-v3 flex-initial relative" v-loading="isSaving">
    <button v-show="isSavingBtn" class="btn-heart" @click.prevent="onFavoriteHandler(hotel)">
      <i
        :class="{ 'text-red': hotel.isFavorite }"
        class="owl-rank-heart"></i>
    </button>
    <div @click="goToPath()"
      class="hotel-card-v3__link block cursor-pointer rounded-sm overflow-hidden no-underline text-grey h-full bg-white">
      <div class="coverImage" v-lazy:background-image="coverExist ? hotelCover : require('@/assets/images/default-room.jpg')">
        <div v-if="hotel.tags && hotel.tags.length > 0" class="absolute flex flex-wrap justify-start items-center mt-4 pin-b pin-l mb-4 ml-4 rounded-sm">
          <template v-for="(tag, index) in hotel.tags">
            <div v-if="index === 0" :key="tag.id" class="text-xs py-4 px-4 bg-black text-white rounded-sm">{{ tag.name || tag }}</div>
          </template>
          <el-tooltip effect="dark" placement="right">
            <div v-if="hotel.tags.length > 1" class="text-xs py-4 px-4 bg-black text-white ml-4 rounded-sm">{{ hotel.tags.length  - 1}}+</div>
            <div slot="content">
              <template v-for="(tag, index) in hotel.tags">
                <div v-if="index > 0" :key="tag.id" class="text-xs py-4 px-4 text-white">{{ tag.name || tag }}</div>
              </template>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="p-8">
        <!-- <div class="text-bold font-bold text-sm mb-8" :class="mapLabel['fontColor']">{{ hotel.typeText }}</div> -->
        <div class="flex items-center">
          <span v-if="hotel.quarantineHotelNote" class="flex items-center text-xs text-grey-darkest font-bold mr-16">
              <img height="14px" width="14px" src="@/assets/quarantine-hotels/icon-hotel.svg" class="mr-4" alt="quarantine-hotel" />
              <span>{{ $t('quarantine.label') }}</span>
          </span>
          <span v-if="hotel.filterHash && hotel.filterHash.star && mapData('star', hotel.filterHash.star).star > 0" class="bg-white rounded-full flex items-center">
            <i class="bg-orange rounded-full text-white owl-rank-star flex items-center justify-center h-4 w-4 text-xs mr-4" />
            <div class="text-xs text-grey-darkest font-bold">{{ $t('unit.star', [$t('number')[mapData('star', hotel.filterHash.star).star]]) }}</div>
          </span>
        </div>
        <p class="hotel-card-v3__title my-4 text-grey-darkest font-bold" :style="!nearby && 'height: 3rem'">{{ mapLabel['name'] }}</p>
        <div v-if="hotel.hotelNameEN && selectedLang !== 'en'" class="text-sm mb-4 text-grey-darkest font-bold">{{ hotel.hotelNameEN }}</div>
        <div class="flex items-center mb-16">
          <span class="hotel-card-v3__location text-xs text-grey-darkest">
            <!-- <span class="text-xs text-grey-darkest">{{ mapLabel['location'] }}</span>
            <div v-if="hotel.type === CARD_TYPE_HOTEL && hotel.hotelType.name !== 'unknown'" class="text-xs text-grey-darkest">
              <span class="mx-4">|</span>{{ hotel.hotelType.name }}
            </div> -->
            <span v-if="hotel.placesText">
              {{ mapLabel['location'] }}
              <span v-if="hotel.hotelType && hotel.hotelType.name !== 'unknown'" :class="{ 'border-l-1 border-grey-dark mx-8 px-8': hotel.placesText }">{{ hotel.hotelType.name }}</span>
            </span>
          </span>
          <!-- <div v-else-if="hotel.type === CARD_TYPE_EXPERIENCE && hotel.saleCount > 0" class="text-xs text-grey-darkest">
            <span v-if="mapLabel['location']" class="mx-4">|</span>{{ $t('mapCard.soldAmount', [hotel.saleCount]) }}
          </div> -->
        </div>
        <div class="flex items-center font-bold justify-between">
          <template v-if="hotel.inStock && hotel.price">
            <div class="flex items-center">
              <div class="text-xl text-grey-darkest">{{ currencySign }} {{ Number(hotel.price) | currencyConvert({inputCurrency: hotel.currency, listInteger: true}) }}</div>
            </div>
          </template>
          <template v-else-if="(typeof hotel.price !== 'undefined')">
            <span class="font-bold text-red">{{ $t('soldOut') }}</span>
          </template>
          <img v-if="hotel.type === CARD_TYPE_HOTEL && hotel.tripAdvisor" :src="hotel.tripAdvisor.logo" style="width: 110px;" :alt="`${hotel.hotelName} - tripAdvisor`">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import tripAdvisor from '@/components/review/tripAdvisor'
import imgInfo from '@/utils/imgInfo'

const CARD_TYPE_EXPERIENCE = 'experience'
const CARD_TYPE_HOTEL = 'hotel'

export default {
  name: 'hotelCardV3',
  components: {
    // tripAdvisor
  },
  props: {
    starData: {
      type: [Array, Object]
    },
    hotel: {
      type: Object
    },
    isSavingBtn: {
      type: Boolean,
      default: true
    },
    nearby: {
      type: Boolean,
      default: false
    },
    abtest: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      CARD_TYPE_EXPERIENCE,
      CARD_TYPE_HOTEL,
      isSaving: false,
      MAGNIFACATION: 1.5,
      coverExist: false
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      isLoadingFavorite: 'hotels/isLoadingFavorite',
      initWidth: 'initWidth'
    }),
    mapLabel: function () {
      const cardType = this.hotel.type

      switch (cardType) {
        case CARD_TYPE_EXPERIENCE:
          return {
            fontColor: 'text-orange-dark',
            name: this.hotel.languageData.name,
            location: this.hotel.languageData.administrativeAreaName
          }
        case CARD_TYPE_HOTEL:
          return {
            fontColor: 'text-blue',
            name: this.hotel.hotelNameLocal,
            location: this.hotel.placesText
          }
      }
      return {}
    },
    hotelCardV3ImageWidth: function () {
      if (this.initWidth >= 1200) {
        return 282
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 348
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 360
      } else if (this.initWidth < 768 && this.initWidth > 430) {
        return 743
      } else {
        return 406
      }
    },
    hotelCover: function () {
      if (this.hotel.imageUrl) {
        return `${this.hotel.imageUrl}?width=${this.hotelCardV3ImageWidth * this.MAGNIFACATION}&format=webp`
      }
      return require('@/assets/images/default-room.jpg')
    }
  },
  methods: {
    goToPath: function () {
      const cardType = this.hotel.type

      switch (cardType) {
        case CARD_TYPE_HOTEL:
          window.dataLayer.push({
            event: 'select_item',
            ecommerce: {
              items: [{
                item_name: this.hotel.hotelNameLocal,
                item_id: this.hotel.hotelUUID
              }]
            }
          })

          // ab test
          if (this.nearby && this.abtest) {
            if (this.abtest === 'A') {
              window.dataLayer.push({
                event: 'item_recommend_A'
              })
            } else {
              window.dataLayer.push({
                event: 'item_recommend_B'
              })
            }
          }

          const route = this.$router.resolve({
            name: 'HotelDetail',
            params: { hotelId: this.hotel.hotelUUID },
            query: {
              ...this.$route.query,
              externalId: this.hotel.hotelUUID,
              searchId: this.hotel.hotelUUID,
              search: this.hotel.hotelNameLocal,
              searchType: 'hotel',
              source: this.hotel.source
            }
          })
          window.open(route.href, '_blank')
          break
        case CARD_TYPE_EXPERIENCE:
          window.open(`https://www.owlting.com/experiences/products/${this.hotel.externalData}`, '_blank')
          break
      }
    },
    mapData: function (type, data) {
      switch (type) {
        case 'star':
          const result = this.starData.find(item => item.filterId === data[0])
          return result
      }
    },
    onFavoriteHandler: function (hotel) {
      this.isSaving = true
      hotel.isFavorite ? this.$emit('removeFavorite', hotel) : this.$emit('addFavorite', hotel)
    }
  },
  async mounted () {
    const exist = await imgInfo.exist(this.hotel.imageUrl)
    this.coverExist = exist
  },
  watch: {
    isLoadingFavorite: function (val, oldVal) {
      if (!val && oldVal) {
        this.isSaving = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.hotel-card-v3
  &__link
    transition: .3s box-shadow
    &:hover
      @apply shadow-md
  .btn-heart
    @apply absolute text-white p-4 outline-none text-xl
    top: 0px
    right: 0px
    z-index: 1
    i.owl-rank-heart
      text-shadow: -1px 0 #eee, 0 1px #eee, 1px 0 #eee, 0 -1px #eee
      @screen md
        &:hover
          @apply text-red-light
  .coverImage
    padding-top: imageRatio(324, 192)
    @apply bg-center bg-cover relative
    border-radius: 20px
    background-color: #f7f7f7
  &__title
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 2
    line-height: 1.5em
  &__location
    @apply flex items-center
    i:before
      @apply ml-0
.el-tooltip__popper.is-dark
  background-color: rgba(#000, 0.65)
</style>
